
import { useMutation } from "@tanstack/react-query";
import { useRouter } from "next/navigation";

import { requestResetPassword, RequestResetPasswordRequest } from "@/api";
import { useUIStore } from "stores/ui.store";

const useRequestResetPassword = () => {
  const { replace } = useRouter();

  const openToast = useUIStore((state) => state.actions.toast.openToast);

  return useMutation({
    mutationFn: (body: RequestResetPasswordRequest) => {
      return requestResetPassword(body);
    },
    onSuccess: (_, { email }) => {
      replace(`/auth/code-verification?email=${email}`);
    },
    onError: (error) => {
      const customError = error as any;

      openToast({ message: customError.response.data.message, variant: "error" });
    },
  });
};

export { useRequestResetPassword };
